/**
 * Roster summary numbers for `ListPage stats` (NextAdmin overview-stats; demo /manage-team header numbers).
 */
import { AlertTriangle, CheckCircle2, DollarSign, Eye, Play } from 'lucide-react';
import type { StatStripCell } from '../../../components/ui/index.js';
import type { EmployeeView } from '../shared';

export function rosterStatCells(employees: EmployeeView[], weeklyCost?: number, weeklyCostTrend = 0): StatStripCell[] {
  const blocked = employees.filter((e) => e.status === 'blocked').length;
  const review = employees.filter((e) => e.status === 'review').length;
  const setup = employees.filter((e) => e.status === 'setup').length;
  const attn = employees.filter((e) => e.attn).length;
  const working = employees.filter((e) => e.status === 'working').length;
  const available = employees.filter((e) => e.status === 'available').length;
  const cost = weeklyCost ?? employees.reduce((sum, e) => sum + (e.cost7d ?? 0), 0);
  const trendLabel = `${weeklyCostTrend < 0 ? '' : '+'}${Math.round(weeklyCostTrend * 100)}% vs last week`;

  return [
    {
      label: attn > 0 ? 'Needs attention' : 'Fleet healthy',
      value: attn > 0 ? attn : 'All clear',
      sub: attn > 0 ? `${blocked} blocked · ${review} in review · ${setup} in setup` : 'No blockers, all gates green',
      severity: attn > 0 ? 'danger' : 'success',
      icon: attn > 0 ? AlertTriangle : CheckCircle2,
    },
    { label: 'Working', value: working, severity: working > 0 ? 'accent' : undefined, icon: Play },
    { label: 'Available', value: available, icon: CheckCircle2 },
    { label: 'Awaiting review', value: review, severity: review > 0 ? 'warning' : undefined, icon: Eye },
    { label: 'Weekly cost', value: `$${cost.toFixed(0)}`, sub: cost > 0 ? trendLabel : undefined, icon: DollarSign },
  ];
}
